import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { CustomerListIdCell } from './customer-list-id.cell';
import { CustomerListIdHeader } from './customer-list-id.header';

export const CustomerListIdColumn: IdentifiedColumnDef<
  GatewayCustomerModel,
  GatewayCustomerModel['id']
> = {
  enableSorting: false,
  header: CustomerListIdHeader,
  cell: CustomerListIdCell,
};
